import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Stack} from 'views/components';
import {Accordion, AccordionDetails, AccordionSummary} from 'views/components';

import {Translate} from 'views/module';

import JobProfileUrl from './job_profile_url/JobProfileUrl';

const JobSettingsData = (props) => {
  const {jobSettingsView: view, setJobSettingsView: setView} = props;

  const handleChange = (panel) => (event, isExpanded) => {
    setView(isExpanded ? panel : '');
  };

  // Accordion configuration array
  const accordions = [
    {
      id: 'PROFILE_URL',
      title: 'career.jobDetail.Information.JobURL',
      Component: JobProfileUrl,
    },
  ];

  return (
    <Stack spacing={2} sx={{mr: 2}}>
      {
        accordions.map(({id, title, Component}) => (
          <Accordion
            key={id}
            expanded={view === id}
            onChange={handleChange(id)}
            sx={{marginBottom: '16px'}}
            TransitionProps={{unmountOnExit: true}}
            disableGutters
          >
            <AccordionSummary
              sx={{
                'flexDirection': 'row-reverse',
                '& .MuiAccordionSummary-content': {
                  marginLeft: '8px',
                },
                '&.Mui-expanded': {
                  minHeight: '0px',
                },
                'borderBottom': '1px solid rgba(0, 0, 0, 0.12)',
                'textTransform': 'uppercase',
              }}
            >
              <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'black'}}>
                <Translate expression={title} />
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                paddingTop: '8px',
                paddingBottom: '0px',
                overflow: 'auto',
              }}
            >
              <Component
                {...props}
              />
            </AccordionDetails>
          </Accordion>
        ))
      }
    </Stack>
  );
};

JobSettingsData.propTypes = {
  jobSettingsView: PropTypes.string.isRequired,
  setJobSettingsView: PropTypes.func.isRequired,
  jobData: PropTypes.object,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(JobSettingsData));
